import {clearfix} from '@xpertdox_js/xdstyle';
import {colors} from '../../DataTable/defaultSettings';

export default {
  container: {
    padding: '12px',
    background: colors.bg.panel,
    color: colors.panelText,
    borderBottom: '1px solid ' + colors.panelBorder,
    borderLeft: '1px solid ' + colors.panelBorder,
  },
  separator: {
    border: '1px solid rgb(218, 220, 222)',
    width: '100%',
    marginTop: 15,
    marginBottom: 15
  },
  checkField: {
    display:'flex',
    flexDirection: 'row',
    alignItems:'center',
    fontSize: '15px',
    // marginBottom: '8px',
    cursor:'pointer',
    marginLeft: 4,
    marginTop: 0,
    marginBottom: 35
  },
  checkField2: {
    fontSize: '14px',
    marginBottom: '8px',
    cursor:'pointer'
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '1.5rem'
  },
  warningMsg: {
    position:'absolute',
    fontSize: '14px',
    margin:'0',
    color: 'rgb(230, 83, 83)'
  },
  errorMsg: {
    position:'absolute',
    fontSize: '12px',
    marginBottom:'5px',
    color: 'rgb(230, 83, 83)'
  },
  textAndSwitch: {
    ...clearfix,
    marginBottom: '10px',
  },
  tasText: {
    float: 'left',
    width: '80%',
    padding: '0 6px',
  },
  tasSwitch: {
    float: 'left',
    width: '20%',
    padding: '0 6px',
  },
  title: {
    margin: '5px 0 0',
    fontSize: '1.6rem'
  },
  tipText: {
    fontSize: '14px',
    display: 'block',
    marginBottom: '5px',
  },
  switchStyles: {
    text: {
      fontSize: '12px',
    },
    container: {
      background: 'rgba(0,8,20,0.68)',
    }
  },
  fieldWrap: {
    ...clearfix,
    // borderBottom: '1px dotted rgba(0,0,0,0.1)',
  },
  field: {
    width: '33.3333%',
    float: 'left',
    // marginBottom: '12px',
    display: 'inline-block',
    position: 'relative',
    padding: '2px 8px 2px 2px',
    borderTop: '1px solid rgba(0, 0, 0, 0)',
    background: 'none',
    fontWeight: 'bold',
  },
  inputStyles: {
    input: {
      border: '1px solid ' + colors.panelBorder,
      boxShadow: 'inset 0 1px 2px ' + colors.opacShadeLt,
      width: '100%',
      // height: '145px',
    }
  },
  save: {
    maxWidth: '120px',
    background: colors.go,
  },
  logs: {
    maxWidth: '150px',
    background: colors.bg.on,
  },
  saveHov: {
    background: colors.goAlt,
  },
  saveNull: {
    background: colors.inactive,
  },
  descriptionInput: {
    display: 'block',
    padding: '5px'
  },
  triageDropdowns: {
    table: {
      width: '100%',
      textAlign: 'center',
      fontSize: '1.25rem'
    },
    col: {
      padding: 5,
      border: '1px solid rgb(218, 233, 247)'
    },
    row: {
      cursor: 'pointer',
    },
    thead: {

    }
  }
}
